<h2 mat-dialog-title>Operatori coinvolti</h2>
<mat-dialog-content>
  @if (loading) {
    <div class="d-flex justify-content-center py-3">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else if (error) {
    <p class="text-danger mb-0">{{ error }}</p>
  } @else if (utenti.length === 0) {
    <p class="text-muted mb-0">Nessun operatore collegato a questa richiesta.</p>
  } @else {
    <mat-list>
      @for (u of utenti; track u.id) {
        <mat-list-item>
          <span class="fw-medium">{{ u.cognome }} {{ u.nome }}</span>
          @if (u.codiceFiscale) {
            <span class="text-muted ms-2">({{ u.codiceFiscale }})</span>
          }
          @if (u.email) {
            <span class="d-block small text-secondary">{{ u.email }}</span>
          }
        </mat-list-item>
      }
    </mat-list>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Chiudi</button>
</mat-dialog-actions>
